<template>
    <div style="height:100%" :class="itemClass">
        <div class="header">
            <img ref="img" src="../assets/lyLogo.jpg" style="width:130px;height:130px;margin:10px"/>
            <div class="info">
                <div class="row">
                    <div class="title"><span>{{data.product_name}}</span></div>
                </div>
                <div class="row">
                    <div class="other"><span>客户名称：</span><span>{{data.customer_name}}</span></div>
                    <div class="other"><span>供料厂商：</span><span>{{data.supplier}}</span></div>
                </div>
                <div class="row">
                    <div class="other"><span>来料日期：</span><span>{{data.come_date}}</span></div>
                    <div class="other"><span>加工规格：</span><span>{{data.product_size}}</span></div>
                </div>
                <div class="row">
                    <div class="other"><span>来料数量：</span><span>{{data.come_count}}</span></div>
                    <div class="other"><span>表面处理：</span><span>{{data.face}}</span></div>
                </div>
            </div>
        </div>
        <div class="content">
            <el-table :data="data.process" height="100%" :stripe="true">
                <el-table-column label="序号" align="center" width="50px">
                  <template slot-scope="scope">
                    <div>{{scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="加工步骤" align="center"></el-table-column>
                <el-table-column prop="require" label="工艺要求" align="center" width="300px">
                    <template slot-scope="scope">
                        <FormatProcessRequire style="text-align: left" :data="scope.row.require"></FormatProcessRequire>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="单价" align="center" width="100px">
                    <template slot-scope="scope">
                        <div>{{Number(scope.row.price) === 0 || isNaN(Number(scope.row.price)) ? '' : Number(scope.row.price).toFixed(2)}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="总计" align="center" width="100px">
                    <template slot-scope="scope">
                        <div>
                            <el-tag v-if="data.come_count * scope.row.price" type="success">{{(data.come_count * scope.row.price).toFixed(2)}}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作员" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-tag style="margin: 0 5px;margin-top:5px" v-for="item in scope.row.operator" :key="item">{{item}}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import FormatProcessRequire from '../components/FormatProcessRequire'

export default {
  components: {
    FormatProcessRequire
  },
  props: ['data', 'itemClass']
}
</script>

<style>
.header{
    height: 150px;
    display: flex;
}
.header .info{
    width: calc(100% - 150px);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.header .info .row{
    display: flex;
    justify-content: center;
}
/* .header .info .name {
    width: 100%;
    float: left;
} */
.header .info .title {
    padding-right: 150px;
    font-size: 30px;
    font-weight: 600;
}
.header .info .other {
    width: 50%;
    padding-left: 20px;
}
.content{
    height: calc(100% - 150px)
}
/* .one .el-table .el-table__row {
    background-color: #99a9bf;
}

.two .el-table .el-table__row {
    background-color: #d3dce6;
}
.one  .el-table .el-table__row td{
    background: #99a9bf !important;
}

.two .el-table .el-table__row td{
    background: #d3dce6 !important;
} */
</style>
